import { createAction, props } from '@ngrx/store';
import { featureKey } from '../state/online-contract.state';
import { Template } from 'app/main/pages/edit-template/edit-template.dto';
import { SigningData } from '../../online-contract.service';
import { RecipientRole } from 'app/main/pages/edit-template/edit-template.dto';

const scope = `[${featureKey}]`;


export const getOnlineContract = createAction(`${scope} Get online contract`, (template_id: number, uuid:string) => ({ template_id, uuid }));
export const getOnlineContractSuccess = createAction(
    `${scope} Get online contract success`,
    (template: Template) => ({ template })
);

export const getOnlineContractFailure = createAction(
    `${scope} Get online contract failure`,
    (error: string) => ({ error })
);

export const signOnlineContract = createAction(`${scope} Sign the online contract`, (data:SigningData,template_id: number) => ({data, template_id }));
export const signOnlineContractSuccess = createAction(
    `${scope} sign online contract success`
);

// The API error interceptor passes a body carrying error.code through whole, and every other failure as its message.
export type SignOnlineContractError = string | { message?: string, error?: { code?: string } };

export const signOnlineContractFailure = createAction(
    `${scope} sign online contract failure`,
    (error: SignOnlineContractError) => ({ error })
);

export const sendInvitation = createAction(`${scope} send online contract invitation`, (data:SigningData,template_id: number) => ({data, template_id }));
export const sendInvitationSuccess = createAction(
    `${scope} send online contract invitation success`
);

export const sendInvitationFailure = createAction(
    `${scope} send online contract invitation failure`,
    (error: string) => ({ error })
);

export const addVisitedRecipientRole = createAction(
  `${scope} Add Visited Recipient Role`,
  props<{ role: RecipientRole[] }>()
);

export const updateVisitedRecipientRole = createAction(
  `${scope} Update Visited Recipient Role`,
  props<{ updatedRole: RecipientRole }>()
);